<template>
    <div
        id="popUpCouponIndicator"
        class="couponIndicatorMain"
    >
        <div
            class="
                frame
            "
        >
            <div
                style="
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                "
            >
                <img
                    :src="`${getShopStaticResouceUrl()}imgs/coupon/close.png`"
                    style="width: 3em;height: 3em;"
                    @click="removeDialog"
                />
            </div>
            <img
                v-if="couponImg"
                :src="`${getShopStaticResouceUrl()}${couponImg}`"
                style="width: 100%"
                @click="goToConsumeTicketDetail"
            />
        </div>
    </div>
</template>

<script>

//
import { getShopStaticResouceUrl } from "#/utils/common.js"

export default {
    name: 'CouponIndicator',

    data()
    {
        return {
            couponImgList: [
                {
                    imgUrl: "imgs/coupon/rush.png",
                    endTime: new Date(2022, 0, 15, 19).valueOf(),
                },
                {
                    imgUrl: "imgs/coupon/rush2.png",
                    endTime: new Date(2022, 0, 16).valueOf(),
                },
                {
                    imgUrl: "imgs/coupon/rush3.png",
                    endTime: new Date(2023, 4, 16).valueOf(),
                },
                {
                    imgUrl: "imgs/coupon/rush4.png",
                }
            ],

            couponImg: null,
            checkCouponInterval: null,
        }
    },

    created()
    {
        this.checkCouponImg();
        
        this.checkCouponInterval = setInterval(() => {
            this.checkCouponImg();
        }, 2000);
    },

    beforeDestroy()
    {
        if(this.checkCouponInterval)
        {
            clearInterval(this.checkCouponInterval);
        }
    },

    methods: {
        checkCouponImg()
        {
            const now = Date.now();

            for(let couponImgConfig of this.couponImgList)
            {
                if(couponImgConfig.endTime == null || now < couponImgConfig.endTime)
                {
                    this.couponImg = couponImgConfig.imgUrl;

                    break;
                }
            }
        },

        removeDialog() {
            this.remove()
        },

        goToConsumeTicketDetail() {
            this.remove();

            //
            window.location.href =
                `${this.getShopFoodMarketHostUrl()}#/coupons`
        },

        getShopStaticResouceUrl()
        {
            return getShopStaticResouceUrl();
        }
    },
}
</script>

<style lang="scss" scoped>

.couponIndicatorMain
{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 9999;
    font-size: $fontSizeContent;
    background-color: $neutralMaskColor;
    display: flex;
    align-items: center;
    justify-content: center;
}

.frame
{
    width: 80vw;
    max-height: 80vh;
}
</style>